import React from 'react'

const AddMarkerIcon = (props) => (
  <svg
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    x='0px'
    y='0px'
    viewBox='0 0 406.4 500'
    style={{
      enableBackground: 'new 0 0 406.4 500',
    }}
    xmlSpace='preserve'
    {...props}
  >
    <style type='text/css'>{'\n\t.st0{fill:#052A30;}\n'}</style>
    <g>
      <path
        className='st0'
        d='M288.8,206.9h-19.9c-9.1,0-16.4,7.3-16.4,16.4c0,9.1,7.3,16.4,16.4,16.4h19.9c9.1,0,16.4-7.3,16.4-16.4 C305.2,214.3,297.8,206.9,288.8,206.9z'
      />
      <path
        className='st0'
        d='M202.2,122.5c-9.1,0-16.4,7.3-16.4,16.4v68h-68c-9.1,0-16.4,7.3-16.4,16.4c0,9.1,7.3,16.4,16.4,16.4h68v68 c0,9.1,7.3,16.4,16.4,16.4s16.4-7.3,16.4-16.4V138.9C218.6,129.9,211.3,122.5,202.2,122.5z'
      />
      <path
        className='st0'
        d='M380.5,103.6c-0.2-0.4-0.4-0.7-0.5-1.1C345.7,42.3,282.3,4.1,210.2,0.4c-1.9-0.2-4.4-0.4-7.1-0.4 C142.9,0,86.2,27,47.6,74.1C7.6,123-8.3,186.4,4.1,248.1c7.3,36.6,26.3,65.1,46.8,93.5l16.6,23c13.2,18.3,26.4,36.5,39.6,54.8 c3.8,5.3,7.5,10.6,11.3,15.9c8.5,12.1,17.3,24.6,26.9,36.4C160,490,179.8,500,201.1,500c0.5,0,1.1,0,1.6,0 c24.3-0.6,47.7-13.6,64.1-35.9c4-5.4,7.8-10.8,11.7-16.2l3.5-4.9c9.9-13.8,20.4-27.7,30.4-41.2c21.3-28.5,43.3-58,62.9-88.3 C414.8,252.5,416.8,168.3,380.5,103.6z M347.7,295.7c-19.1,29.5-40.7,58.5-61.6,86.5c-10.1,13.6-20.6,27.7-30.8,41.6l-3.5,4.9 c-3.8,5.3-7.6,10.6-11.4,15.8c-10.2,13.8-24.5,22.2-38.4,22.5c-11.8,0.3-22.5-5.3-31.3-16c-8.9-10.9-17.3-23-25.5-34.6 c-3.8-5.5-7.6-10.9-11.5-16.3c-13.2-18.3-26.4-36.6-39.6-54.9l-16.6-23c-18.3-25.4-35.2-50.6-41.2-80.8 c-10.4-52,2.9-105.5,36.7-146.8c32.3-39.5,79.7-62.1,130.1-62.1c1.5,0,2.9,0.1,4.4,0.3c0.2,0,0.5,0,0.7,0.1 c60.5,3,113.8,34.7,142.7,84.7c0.2,0.3,0.3,0.7,0.5,1C382.4,173.3,381,244.4,347.7,295.7z'
      />
    </g>
  </svg>
)
export default AddMarkerIcon
